import React, { useEffect } from "react"
import { Box } from "@mui/material"

import { DateRangePicker, UsersAutocomplete } from "@components/CommonFilters/@components"
import {BACKEND_APIS, DATE_PRESETS} from "@constants"
import {companyUsers, dateRange, userData} from "@signals"
import { AppFilterBar, secondaryButtonSx } from "@components"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import {formatDate, postExcel} from "@ui-seeker/utils";


export default function SearchAnalyticsFilters() {

	useEffect(() => {
		dateRange.value = [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]
	}, [])

	return <AppFilterBar actions={<ButtonLoadingSeeker
		variant="outlined"
		sx={secondaryButtonSx}
		startIcon={<IconSeeker icon="file-excel"/>}
		tooltip="Download dashboard excel"
		onClick={ () => postExcel(`${BACKEND_APIS.SEARCH_ANALYTICS_EXCEL}`, {
			user: userData.value.username,
			uid: companyUsers.value,
			startBookingDate: formatDate(dateRange.value[0], { format: 'yyyy-MM-dd' }),
			endBookingDate: formatDate(dateRange.value[1], { format: 'yyyy-MM-dd' })
		})}
	>
		Download Excel
	</ButtonLoadingSeeker>}>
		<Box data-tour-id="tour-filter-users" sx={{ width: 240 }}>
			<UsersAutocomplete/>
		</Box>
		<Box sx={{ width: 290 }}>
			<DateRangePicker sx={{ height: 2, width: "100%" }} ranges={DATE_PRESETS}/>
		</Box>
	</AppFilterBar>
}
